/**
 * @generated SignedSource<<fd73fd915e48c4a426112bc260bf0f05>>
 * @relayHash 897e785dd82d688a8b92757085b3206d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 59653e087b319c6c1799a443fab7349acbf7cc3fb9daf3db605b9a9f1d3ae86a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type cascadingSelectIssueTransitionIssueAdjustmentsQuery$variables = {
  ari: string;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
  filterByIdChild?: JiraFieldOptionIdsFilterInput | null | undefined;
};
export type cascadingSelectIssueTransitionIssueAdjustmentsQuery$data = {
  readonly node: {
    readonly parentOptions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly childOptions: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly value: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly value: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type cascadingSelectIssueTransitionIssueAdjustmentsQuery = {
  response: cascadingSelectIssueTransitionIssueAdjustmentsQuery$data;
  variables: cascadingSelectIssueTransitionIssueAdjustmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterById"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByIdChild"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ari"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "value"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "filterById",
          "variableName": "filterById"
        }
      ],
      "concreteType": "JiraParentOptionConnection",
      "kind": "LinkedField",
      "name": "parentOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraParentOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraParentOption",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "filterById",
                      "variableName": "filterByIdChild"
                    }
                  ],
                  "concreteType": "JiraOptionConnection",
                  "kind": "LinkedField",
                  "name": "childOptions",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraOptionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraOption",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v2/*: any*/),
                            (v3/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraCascadingSelectField"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "cascadingSelectIssueTransitionIssueAdjustmentsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cascadingSelectIssueTransitionIssueAdjustmentsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v4/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "59653e087b319c6c1799a443fab7349acbf7cc3fb9daf3db605b9a9f1d3ae86a",
    "metadata": {},
    "name": "cascadingSelectIssueTransitionIssueAdjustmentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "05c858c87aebae163faf43d2a0d580f3";

export default node;
